module.exports = __webpack_public_path__ + "img/Airbnb-Hybrid-stress-buster-.494d4a55.jpg";